const accountContext = {};

export default accountContext;
